module.exports = __webpack_public_path__ + "img/e677167.png";